import React from "react";
import styled from "styled-components";
import PizzaLogo from "../assets/dishes-img/pizza-logo-white.png";
import { ReactComponent as Twitter } from "../assets/social-icons/svg/013-twitter-1.svg";
import { ReactComponent as Facebook } from "../assets/social-icons/svg/045-facebook.svg";
import { ReactComponent as Instagram } from "../assets/social-icons/svg/034-instagram.svg";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <FooterWrapper>
      <ul className="parent-container">
        <div>
          <li>
            <img src={PizzaLogo} height="100px" alt="pizza-brand" />
          </li>
        </div>

        <div className="mobile-version">
          <li>
            <span>
              <Link to="/about"> About </Link>
            </span>
          </li>

          <li>
            <span>
              <Link to="/"> Order online </Link>
            </span>
          </li>
        </div>

        <div className="mobile-version">
          <a href="https://twitter.com/">
            <Twitter  />
          </a>
          <a href="https://facebook.com/">
            <Facebook  />
          </a>
          <a href="https://instragram.com/">
            <Instagram  />
          </a>
        </div>
      </ul>
      <div className="border-line"></div>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`

li {
  list-style-type: none;
  margin-left: 10px;
}

  a > svg {
    width: 15px;
    height: 15px;
    fill: var(--footerSocialIcons);
    cursor: pointer;
    margin-left: 10px;
  }

  height: 130px;

  span a {
    color: #aaaaaa;
    font-size: 15px;
    text-decoration: none;
  }

  ul {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  ul div {
    display: flex;
  }

  p {
    color: var(--checkout-product-descr);
    font-size: 14px;
  }
  background: var(--productTitle);

  @media screen and (max-width: 540px ) {
    ul > .mobile-version {
      display: flex;
      flex-direction: column;
    }
  };


`;

export { Footer as default };
